<template>
  <div class="card mt-5">
      <div class="card__body">
        <div class="half">
          <div class="image">
            <img :src="product.image_url" alt="">
          </div>
        </div>
        <div class="half" id="description-product">
          <div class="featured_text">
            <h1>{{product.name}}</h1>
            <hr>
            <p class="price">Rp. {{product.price}}</p>
          </div>
          <div class="description">
            <p>{{product.description}}</p>
          </div>
          <div v-if="product.stock > 0">
            <span class="stock">{{product.stock}} In stock</span>
          </div>
          <div v-if="product.stock == 0">
            <span class="stock">OUT OF STOCK</span>
          </div>
          <div class="reviews">
            <ul class="stars">
              <li><i class="fa fa-star"></i></li>
              <li><i class="fa fa-star"></i></li>
              <li><i class="fa fa-star"></i></li>
              <li><i class="fa fa-star"></i></li>
              <li><i class="fa fa-star-o"></i></li>
            </ul>
            <span>(190 reviews)</span>
          </div>

            <div class="action">
                <div>
                    <button class="btn btn-secondary mr-3 mb-3" @click="doBack" type="button">Back</button>
                    <button v-if="product.stock > 0" class="btn btn-primary mb-3" @click="addToCart(product.id)" type="button">Add to cart</button>
                </div>
                <div v-if="product.stock == 0">
                    <h3>OUT OF STOCK</h3>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import swal from 'sweetalert';
import axios from 'axios'

export default {
  name: 'ProductDetails',
  components: {

  },
  data() {
    return {
      id: this.$route.params.productId,
      product: {},
      // url: 'http://localhost:3000'
      url: 'https://dry-savannah-57278.herokuapp.com'
    };
  },
  methods: {
    backHome() {
      this.$router.push({ name: 'Home' });
    },
    showProduct() {
      axios({
        method: 'get',
        url: `${this.url}/products/${this.id}`
      })
        .then(({ data }) => {
          this.product = data.product;
        })
        .catch(err => {
          console.log(err)
        })
    },
    doBack() {
        this.$router.go(-1)
    },
    addToCart (id) {
        if(!localStorage.token){
            this.$root.$emit('bv::show::modal','modal-1')
        } else {
            swal({
                title: 'Do you want to add this product to cart?',
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
             })
            .then(confirm=>{
                if(confirm){
                    return axios({
                        url: `${this.url}/carts/${id}`,
                        method: 'post',
                        data: {
                            amount: 1,
                        },
                        headers: {
                            token: localStorage.token
                        }
                    })
                }
            })
            .then(response=>{
                if (!response) {
                    swal('Done!','Cancel add product','info')
                } else {
                    swal('Please check your cart',response.data.message,'success')
                }
            })
            .catch(err=>{
                console.log(err)
            })    
        }  
    }
  },
  mounted() {
    this.showProduct();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Fjalla+One|Montserrat:300,400,700,800|Open+Sans:300");

#description-product {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card {
  background: #fff;
}

.card .card__body {
  padding: 0 40px;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-flow: row no-wrap;
  margin-bottom: 25px;
}
.card .card__body > .half {
  box-sizing: border-box;
  padding: 0 15px;
  -webkit-box-flex: 1;
          flex: 1 0 50%;
}
.card .card__body .featured_text h1 {
  margin: 0;
  padding: 0;
  font-weight: 800;
  font-family: "Montserrat", sans-serif;
  font-size: 32px;
  line-height: 50px;
  color: #181e28;
}
.card .card__body .featured_text p {
  margin: 0;
  padding: 0;
}
.card .card__body .featured_text p.sub {
  font-family: "Montserrat", sans-serif;
  font-size: 26px;
  text-transform: uppercase;
  color: #686e77;
  font-weight: 300;
  margin-bottom: 5px;
}
.card .card__body .featured_text p.price {
  font-family: "Fjalla One", sans-serif;
  color: #a1cc16;
  font-size: 26px;
}
.card .card__body .image {
  padding-top: 15px;
  width: 100%;
}
.card .card__body .image img {
  display: block;
  max-width: 100%;
  height: auto;
}
.card .card__body .description {
  margin-bottom: 25px;
}
.card .card__body .description p {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  line-height: 27px;
  font-size: 16px;
  color: #555;
}
.card .card__body span.stock {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  color: #a1cc16;
}
.card .card__body .reviews .stars {
  display: inline-block;
  list-style: none;
  padding: 0;
}
.card .card__body .reviews .stars > li {
  display: inline-block;
}
.card .card__body .reviews .stars > li .fa {
  color: #f7c01b;
}
.card .card__body .reviews > span {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  margin-left: 5px;
  color: #555;
}
</style>